// ** Reducers Imports
import navbar from './navbar'
import layout from './layout'
import auth from './reducers/Auth'
import thing from "./reducers/operator/thing"
import file from "./reducers/operator/FileSys"
import reference from "./reducers/operator/Reference"
import admin from "./reducers/admin/Controller"
import soato from "./reducers/admin/Soato"
import reestr_home from "./reducers/home-page/reestr"
import statistics from "./reducers/home-page/statistic"
import give from "./reducers/admin/GiveThing"
import cache from "./reducers/CacheData"
import notify from "./reducers/operator/notify"
import report from "./reducers/admin/Reports"
import reportDev from "./reducers/developer/reports"
import config from "./reducers/developer/config"

const rootReducer = {
  auth,
  navbar,
  layout,
  thing,
  admin,
  file,
  reference,
  soato,
  reestr_home,
  statistics,
  give,
  cache,
  notify,
  report,
  reportDev,
  config
}

export default rootReducer
